import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import Select from 'react-select';

class TrainingsEditTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: false,
      id: this.props.training_id,
      name: this.props.training_data.name,
      target_id: this.props.training_data.target_id,
      reference: this.props.training_data.reference,
      description: this.props.training_data.description,
      short_name: this.props.training_data.short_name,
    };
    this.editar = this.editar.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(typeof this.state.name === 'undefined') {
      this.setState({
        id: newProps.training_id,
        name: newProps.training_data.name,
        target_id: newProps.training_data.target_id,
        reference: newProps.training_data.reference,
        description: newProps.training_data.description,
        short_name: newProps.training_data.short_name,
        hours: newProps.training_data.hours,
      });
    }
    if(Array.isArray(newProps.lista_targets)) {
      this.setState({lista_targets: newProps.lista_targets});
    }
  }

  // Fetch salvando a edição
  editar(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      name: this.state.name,
      target_id: this.state.target_id,
      reference: this.state.reference,
      description: this.state.description,
      short_name: this.state.short_name,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamento', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} />
  <form onSubmit={this.editar}> 
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>Nome do treinamento:</label>
          <input type="text" name="name" className="form-control" placeholder="Nome do treinamento" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>Nome Curto:</label>
          <input maxLength={5} type="text" name="short_name" className="form-control" placeholder="Nome Curto (05 caracteres)" value={this.state.short_name} onChange={this.handleChange.bind(this, 'short_name')} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>Público alvo:</label>
          <Select
            className="form-field-name"
            name="target_id"
            value={this.state.target_id}
            searchable={true}
            placeholder={'Selecionar público alvo'}
            onChange={this.handleSelectChange.bind(this, 'target_id')}
            options={this.state.lista_targets}
          />    
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>Descrição:</label>
          <textarea style={{ height: 200 }} type="text" name="description" className="form-control" placeholder="Descrição" value={this.state.description} onChange={this.handleChange.bind(this, 'description')} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>Referência:</label>
          <input type="text" name="reference" className="form-control" placeholder="Referência" value={this.state.reference} onChange={this.handleChange.bind(this, 'reference')} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-12">
        <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Salvar edição</button>
      </div>
    </div>
  </form>
</div>
    );
  }
}

export default TrainingsEditTab;



// WEBPACK FOOTER //
// ./src/Components/Trainings/Elements/TrainingsEditTab.js